module.exports = {"addButtonText":"生成","settingType":"设定类型","wafRuleList":"白名单","isEnabled":"启用","editWafRule":"编辑白名单","addWafRule":"新增白名单","reachMaxWafRuleListLength":"最多仅能新增 {maxWafRuleListLength} 条白名单","wafRuleModalFormValidationError":"请完成表单内容","addText":"新增条件","collapseText":"收合","wafRule":{"name":{"label":"名称","placeholder":"白名单名称"},"isEnabled":{"label":"启用"},"rules":{"label":"规则","rule":{"type":"类别","name":"名称","isPositive":"符合"}}},"wafRuleListIsNotEnabled":"目前平台不支持此白名单设置"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/intelligentProtectionSettings.json
// module id = 0yLA
// module chunks = 3